import styled from '@emotion/styled';

const Container = styled.div`
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px;
  width: 100%;
  background-color: var(--dk-bg-subtle, #f9fafb);
`;

const StyledIconBackGround = styled.div`
  padding: 8px;
  border-radius: 8px;
  background: linear-gradient(
      0deg,
      rgba(199, 122, 196, 0.12) 0%,
      rgba(199, 122, 196, 0.12) 100%
    ),
    #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
`;

const Divider = styled.div`
  height: 12px;
  width: 1px;
  background-color: var(--dk-bg-strong, #e7e9ec);
`;

export { Container, StyledIconBackGround, Divider };
